import {EmptyState as ChakraEmptyState, EmptyStateRootProps, VStack} from '@chakra-ui/react'
import {ReactNode} from 'react'
import {IconType} from 'react-icons/lib'
import {LuTextSearch} from 'react-icons/lu'

const sizes = {
  md: {
    iconSize: 32,
    fontSize: 'md',
  },
  sm: {
    iconSize: 24,
    fontSize: 'sm',
  },
} as const

export interface EmptyStateProps extends EmptyStateRootProps {
  title: string
  description?: ReactNode
  icon?: IconType
  size?: keyof typeof sizes
}

export function EmptyState({
  icon = LuTextSearch,
  title,
  description,
  size = 'md',
  children,
  ...props
}: EmptyStateProps) {
  return (
    <ChakraEmptyState.Root {...props}>
      <ChakraEmptyState.Content gapY="4">
        <ChakraEmptyState.Indicator>{icon?.({size: sizes[size].iconSize})}</ChakraEmptyState.Indicator>

        <VStack textAlign="center" gapY="4">
          <ChakraEmptyState.Title fontSize={sizes[size].fontSize}>{title}</ChakraEmptyState.Title>

          {description && <ChakraEmptyState.Description>{description}</ChakraEmptyState.Description>}

          {children}
        </VStack>
      </ChakraEmptyState.Content>
    </ChakraEmptyState.Root>
  )
}
